import FormElement
    from "./FormElement";
import useFormMultipleField
    from "../../../hooks/useFormMultipleField";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel
} from "@mui/material";
import {useTheme} from "@mui/material/styles";

const FormCheckboxField = ({
                               template = {},
                               values = {},
                               defaultAnswer = {},
                               onChange,
                               onBlur,
                               disabled = false,
                           }) => {
    const {hiddenLabel} = useTheme();
    const {
        options,
        answers,
        otherProps: otherPropsRaw,
        otherElement,
    } = useFormMultipleField({
        template,
        values,
        defaultAnswer,
        onChange,
        disabled,
        hiddenLabel
    });

    const {
        content,
        name,
    } = template;

    const {required, ...otherProps} = otherPropsRaw;

    const {
        ignoreIfHidden, // @TODO
        value: possibleValues,
        linkedList, // @TODO
        dataSource, // @TODO
    } = content;

    const generateCheckboxValue = (option) => (
        {
            [option.id]: option.item
        }
    );

    const handleOnCheckboxChange = (event) => {
        const selectedOption = options.find(({item}) => item == event.target.value);

        onChange(generateCheckboxValue(selectedOption), event.target.checked === true ? 'APPEND_ANSWER' : 'DELETE_ANSWER');
    }

    return (
        <FormElement id={template.id} hiddenLabel={hiddenLabel} label={content.question} className="fz-form-element-multiple" required={required}>
            <div className="fz-form-field-multiple-container" id={template.id}>
                <FormControl>
                    {hiddenLabel ? (<FormLabel id={template.id}>{content.question}</FormLabel>) : null}

                    <FormGroup>
                        {options.map((option, index) => {
                            const checkedProp = {}

                            checkedProp.checked = !!answers[option.id];

                            return (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <Checkbox name={`${name}[]`}
                                                  {...checkedProp}
                                                  onBlur={onBlur}
                                                  value={option.item}
                                                  onChange={handleOnCheckboxChange}
                                                  {...otherProps} />
                                    }
                                    label={option.item}
                                />
                                // <label key={index}>
                                //     <input value={option.item} {...checkedProp} name={`${name}[]`}
                                //            type="checkbox"
                                //            autoComplete="off"
                                //            onBlur={onBlur}
                                //            onChange={handleOnCheckboxChange}
                                //            {...otherProps}
                                //     /> {option.item}
                                // </label>
                            );
                        })}

                    </FormGroup>
                </FormControl>

            </div>
            {otherElement(disabled)}
        </FormElement>
    )
}

export default FormCheckboxField;